export default __webpack_public_path__ + "static/media/92.bed19531.png";